// @ts-expect-error
import flowers from './contact-flowers.svg'

export default flowers
